import { Context } from "./Reducers/Store";
import React, { useCallback, useState, useEffect, useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";
import AlertComponent from "./Components/AlertComponent";

function RequireAuth({ children, roles = [] }) {
  const [state, dispatch] = useContext(Context);
  let location = useLocation();

  if (!state.isLogged) {
    return <Navigate to="/welcome" state={{ from: location }} replace />;
  } else {
    if (roles != null && roles.length > 0) {
      if (!roles.includes(state.profile?.subscription?.role)) {
        AlertComponent("Error", "Your user is not authorized to access this resource.", { icon: `error` });
        return <Navigate to="/" replace />;
      }
    }

    if (!state.profile?.subscription?.role && location.pathname != "/industryandteammembers" && location.pathname != "/selectplan" && location.pathname != "/payment" && location.pathname != "/subscriptionCompleted")
      return <Navigate to="/industryandteammembers" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireAuth;
